import React from 'react';
import ReactDOM from 'react-dom/client';
// Fonts are bundled with the site (not loaded from Google), so visitors' IP
// addresses aren't sent to a third party just to show text.
import '@fontsource/fredoka/400.css';
import '@fontsource/fredoka/500.css';
import '@fontsource/fredoka/600.css';
import '@fontsource/fredoka/700.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
// Arabic letters use Baloo Bhaijaan 2 (a rounded font like Fredoka). It comes
// after the other fonts, so only its Arabic part ever downloads.
import '@fontsource/baloo-bhaijaan-2/400.css';
import '@fontsource/baloo-bhaijaan-2/600.css';
import '@fontsource/baloo-bhaijaan-2/700.css';
import '@fontsource/baloo-bhaijaan-2/800.css';
import './index.css';
import App from './App';
// The holiday events' sounds (see src/lib/season.js).
import './lib/eventSounds';
import reportWebVitals from './reportWebVitals';
import { initConsent } from './lib/consent';
import { I18nProvider, detectLang, loadLang } from './i18n';
import { langFromPath } from './i18n/paths';

initConsent();

// Show the page in the language of its address (/de/…), or the visitor's
// language, once that language's words have downloaded.
const root = ReactDOM.createRoot(document.getElementById('root'));
const wanted = langFromPath(window.location.pathname) || detectLang();
loadLang(wanted)
  .catch(() => 'en')
  .then((lang) =>
    root.render(
      <React.StrictMode>
        <I18nProvider initial={lang}>
          <App />
        </I18nProvider>
      </React.StrictMode>
    )
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
